import { createFileRoute } from "@tanstack/react-router";
import { GitHubCallbackPage } from "./-callback/GitHubCallbackPage";

type Search = {
  installation_id?: number;
  setup_action?: "install" | "update" | "request";
  state?: string;
  code?: string;
};

/** Where GitHub sends people back after installing the Guv GitHub app (the app's callback URL). */
export const Route = createFileRoute("/github/callback")({
  staticData: { title: "Connecting GitHub" },
  validateSearch: (s: Record<string, unknown>): Search => ({
    installation_id: Number(s.installation_id) || undefined,
    setup_action:
      s.setup_action === "install" ||
      s.setup_action === "update" ||
      s.setup_action === "request"
        ? s.setup_action
        : undefined,
    state: typeof s.state === "string" ? s.state : undefined,
    code: typeof s.code === "string" ? s.code : undefined,
  }),
  component: GitHubCallbackPage,
});
